module.exports = __webpack_public_path__ + "static/008522-6ea57f9c5236059404ec321b3c84ff46.jpg";